// extracted by mini-css-extract-plugin
export default {"writeComment":"WriteComment_writeComment__cQ7jy","header":"WriteComment_header__b+2jp","textareaInput":"WriteComment_textareaInput__k0zin","btns":"WriteComment_btns__qTKwJ"};